import { convertArrayToCamelCase, convertToCamelCase } from '@skytech/utils'

import type {
  SalaryDeductionApplication,
  SalaryDeductionApplicationExtended,
  SalaryDeductionPolicyHistoryRow,
} from '@/modules/applications/salary-deduction/types'
import {
  API_ROUTE_SALARY_DEDUCTION_APPLICATION,
  API_ROUTE_SALARY_DEDUCTION_APPLICATIONS,
  API_ROUTE_SALARY_DEDUCTION_APPLICATION_POLICY_HISTORY,
  API_ROUTE_SALARY_DEDUCTION_APPLICATION_STATUS,
} from '@/resources/api-routes'
import { get, post } from '@/util/auth'

const salaryDeductionApplicationResources = {
  get: async (applicationId: number) => {
    const application = await get<Record<string, unknown>>(
      API_ROUTE_SALARY_DEDUCTION_APPLICATION.replace(':applicationId', String(applicationId))
    )
    const parsedApplication = convertToCamelCase(application) as Omit<
      SalaryDeductionApplicationExtended,
      'whiteLabelId'
    > & { whitelabelId?: number }
    const mappedKeyApplication = {
      ...parsedApplication,
      whiteLabelId: parsedApplication.whitelabelId,
    }
    delete mappedKeyApplication.whitelabelId

    return mappedKeyApplication as SalaryDeductionApplicationExtended
  },
  getList: async () => {
    const applications = await get<Record<string, unknown>[]>(
      API_ROUTE_SALARY_DEDUCTION_APPLICATIONS
    )
    const parsedApplications = convertArrayToCamelCase(applications)

    return parsedApplications as SalaryDeductionApplication[]
  },
  getPolicyHistory: async (costObjectId: number) =>
    get<SalaryDeductionPolicyHistoryRow[]>(
      API_ROUTE_SALARY_DEDUCTION_APPLICATION_POLICY_HISTORY.replace(
        ':costObjectId',
        String(costObjectId)
      ),
      true
    ),

  // Mutations
  setStatus: ({ applicationId, statusId }: { applicationId: number; statusId: number }) =>
    post(
      API_ROUTE_SALARY_DEDUCTION_APPLICATION_STATUS.replace(
        ':applicationId',
        String(applicationId)
      ),
      {
        status: statusId,
      }
    ),
}

export default salaryDeductionApplicationResources
